import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { EducationService } from './education.service';
import { CandidateEducation } from '../candidate.interface';
const service = new EducationService();

export interface EducationState {}

const EducationStore: Module<EducationState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async postEducation(state, { candidateId, education }: { candidateId: number; education: CandidateEducation }) {
         const response = await service.postEducation(candidateId, education);
         return response.data;
      },
      async patchEducation(state, { candidateId, education }: { candidateId: number; education: CandidateEducation }) {
         const response = await service.patchEducation(candidateId, education);
         return response.data;
      },
      async deleteEducation(state, { candidateId, educationId }: { candidateId: number; educationId: number }) {
         const response = await service.deleteEducation(candidateId, educationId);
         return response.data;
      },
   },
};

export default EducationStore;
